<div class="row mx-0 my-3">
    <div class="col-12">
        <p class="mb-0 sg-section-title">Solar News & Updates</p>
    </div>
</div>
<section class="sg-preview-section ">
    <div class="row mx-0 pl-3 mb-3">
        <!-- <ol style="padding-left: 0;">
            <li style="list-style-type: none;" *ngFor="let item of newsArray">
                <mat-card class="pt-1 pl-0 w-100">
                    <div class="row mx-0 pl-3 sg-card-date mb-2">
                        <div class="col-4 pl-2"> {{item.date}}</div>
                    </div>
                    <div class="row mx-0 pl-3">
                        <div class="col-1 pr-1 px-0 d-flex justify-content-center">
                            <p class="mb-0">
                            <span class="material-icons-outlined">{{item.iconClass}}</span>
                            </p> -->
                            <!--Use this sg-priority-marker class if it is priority item-->
                        <!-- </div>
                        <div class="col-11 pr-0">
                            <h4 class="d-flex">
                                <span class="font-weight-bold">{{item.title}}</span>
                            </h4>
                            <p class="mb-1 sg-preview-content">
                                {{item.message}}
                                ..<span class="sg-read-more" style="white-space: nowrap;" (click)="onReadMoreClick(item.openValue)">read more</span>
                            </p>
                        </div>
                    </div>
                </mat-card>
                <div style="height:10pt"></div>
            </li>
         </ol> -->
         <ng-container  *ngFor="let item of pageContents">
            <mat-card class="pt-1 pl-0 w-100 mb-2"> <!-- *ngIf="item.isActive == 'Yes'" -->
                <div class="row mx-0 pl-3 sg-card-date mb-2">
                    <div class="col-4 pl-2"> {{item.startDate | date: 'MMM/dd/yyyy'}}</div>
                </div>
                <div class="row mx-0 pl-3">
                    <div class="col-1 pr-1 px-0 d-flex justify-content-center">
                        <p class="mb-0" *ngIf="item.type == 'Policy'"
                        [ngClass]="item.highImportance == true || item.isUrgent == true ? 'sg-priority-marker' : ''">
                            <span class="material-icons-outlined">
                                privacy_tip
                            </span>
                        </p>
                        <p class="mb-0" *ngIf="item.type == 'Document'"
                        [ngClass]="item.highImportance == true || item.isUrgent == true ? 'sg-priority-marker' : ''">
                            <span class="material-icons-outlined">
                                description
                            </span>
                        </p>
                        <p class="mb-0" *ngIf="item.type == 'Date'"
                        [ngClass]="item.highImportance == true || item.isUrgent == true ? 'sg-priority-marker' : ''">
                            <span class="material-icons-outlined">
                                event
                            </span>
                        </p>
                        <!--Use this sg-priority-marker class if it is priority item-->
                    </div>
                    <div class="col-11 pr-0">
                        <h4 class="d-flex">
                            <span class="material-icons-outlined" style="color: #cc444b;left: -2px;" 
                            *ngIf="item.highImportance == true || item.isUrgent == true">
                                priority_high
                                </span>
                            <span class="font-weight-bold">{{item.sectionHeader}}</span>
                        </h4>
                        <p class="mb-1 sg-preview-content" style="word-break: break-all;">
                            {{item.sectionDescription | slice:0:200}}
                            ..<span class="sg-read-more" style="white-space: nowrap;" (click)="onReadMoreClick(item.openValue)">read more</span>
                        </p>
                    </div>
                </div>
            </mat-card>
            <div style="height:10pt"></div>
        </ng-container>
    </div>
</section>